import {DefaultTheme} from "react-native-paper";

export const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    text: "#2F2F2F",
    primary: "#f6821f",
    secondary: "#1F2732",
    error: "#ED1C24",
  },
};
